import React from "react";
import {Route, Switch} from "react-router-dom";
import asyncComponent from "util/asyncComponent";

const Attendance = ({match}) => (
  <Switch>
    <Route path={`${match.url}`} component={asyncComponent(() => import('../../components/Attendance/Attendance'))}/>
  </Switch>
);

export default Attendance;
